app.service("TemplateConfig", ['$rootScope', function ($rootScope) {


    this.getTemplate = function (routeModel, stateIndex) {
        const stateIDs = routeModel.state_ids;

        const indexState = stateIndex < routeModel.state_list.length ? routeModel.state_list[stateIndex] : null;
        const parentState = stateIndex > 0 ? routeModel.state_list[stateIndex - 1] : null;

        const stateModelID = indexState ? indexState.model_id : null;

        const parentStateModelID = parentState ? parentState.model_id : null;
        const parentStateChoiceID = parentState ? parentState.choice_id : null;
        const parentStateStateIDs = parentState ? parentState.state_ids : {};

        if (parentStateStateIDs.method_input_id === "filter") {
            if (stateIDs.browse_id === "component") {

                if (stateIDs.component_id === "door") {
                    return "views/browse/filter/browse-filter-door.htm";
                }
            }
            return "views/browse/filter/browse-filter.htm";
        }

        if (stateModelID === "room") {
            return "views/browse/property/browse-property-room.htm";
        }

        if (stateModelID === "solution") {
            return "views/browse/property/browse-property-solution.htm";
        }

        if (stateModelID === "door_type") {
            return "views/browse/property/browse-property-door-type.htm";
        }

        if (stateModelID === "site_range") {
            return "views/browse/property/browse-property-site-range.htm";
        }

        if (stateModelID === "colour_route") {
            return "views/browse/property/browse-property-colour.htm";
        }

        if (stateModelID === "style_route") {
            return "views/browse/property/browse-property-style.htm";
        }

        if (stateModelID === "assembly") {
            return "views/browse/property/browse-property-assembly.htm";
        }

        if (stateModelID === "tab") {

            if (stateIDs.component_id === "promotional") {
                return "views/browse/custom/browse-custom-promotional-tab.htm";
            }
            return "views/browse/layout/browse-layout-tab.htm";
        }

        if (stateModelID === "tile") {
            return "views/browse/layout/browse-layout-tile.htm";
        }

        if (stateModelID === "select") {
            return "views/browse/layout/browse-layout-select.htm";
        }

        if (stateModelID === "edge_option") {
            return "views/browse/property/browse-property-edge-option.htm";
        }

        if (stateModelID === "handle_colour") {
            return "views/browse/property/browse-property-handle-colour.htm";
        }

        if (stateModelID === "clicbox_colour") {
            return "views/browse/property/browse-property-clicbox-colour.htm";
        }

        if (stateModelID === "method_input") {

            if (stateIDs.browse_id === "solution") {
                return "views/browse/journey/browse-journey-solution.htm";
            }
            return "views/browse/layout/browse-layout-method-input.htm";
        }


        if (stateModelID === "method_product") {
            return "views/browse/layout/browse-layout-method-product.htm";
        }

        if (stateModelID === "collection_product") {

            if (stateIDs.base_component_id === "solution") {
                if (stateIDs.browse_id !== "solution") {
                    return "views/browse/product/browse-product-matrix-component.htm";
                }
                return "views/browse/product/browse-product-overview-solution.htm";
            }
            if (stateIDs.base_component_id === "stock") {
                return "views/browse/product/browse-product-list-stock.htm";
            }
            if (stateIDs.base_component_id === "hettich") {
                return "views/browse/product/browse-product-list-hettich.htm";
            }
            if (stateIDs.base_component_id === "cabinet_kitchen") {
                return "views/browse/product/browse-product-list-cabinet-kitchen.htm";
            }
            if (stateIDs.base_component_id === "cabinet_bedroom") {
                return "views/browse/product/browse-product-list-cabinet-bedroom.htm";
            }

        }

        if (stateModelID === "individual_product") {

            if (stateIDs.base_component_id === "door") {

                if (stateIDs.parent_category_id === "door_multi_panel") {
                    return "views/browse/product/browse-product-individual-door-multi-panel.htm";
                }
                if (stateIDs.parent_category_id === "door_sloping") {
                    return "views/browse/product/browse-product-individual-door-sloping.htm";
                }
                if (stateIDs.parent_category_id === "door_sloping_calculator") {
                    return "views/browse/product/browse-product-individual-door-sloping-calculator.htm";
                }
                return "views/browse/product/browse-product-individual-door.htm";
            }

            if (stateIDs.base_component_id === "frame") {
                return "views/browse/product/browse-product-individual-frame.htm";
            }

            if (stateIDs.base_component_id === "solution") {
                return "views/browse/product/browse-product-individual-solution.htm";
            }

            if (stateIDs.base_component_id === "panel") {
                return "views/browse/product/browse-product-individual-panel.htm";
            }

            if (stateIDs.base_component_id === "wrap") {
                return "views/browse/product/browse-product-individual-wrap.htm";
            }

        }

        if (stateModelID === "component") {
            if (stateIDs.browse_id === "site_range") {
                return "views/browse/custom/browse-custom-component-site-range.htm";
            }
        }

        if (stateModelID === "component") {
            return "views/browse/property/browse-property-component.htm";
        }

        if (parentStateModelID === "browse") {
            if (parentStateChoiceID === "overview") {
                return "views/browse/browse-overview.htm";
            }
        }


        if (parentStateModelID === "range_info") {

            if (parentStateChoiceID === "kitchen_rigid_flat_pack") {
                return "views/browse/range-info/browse-range-info-kitchen-rigid-flatpack.htm";
            }

            if (parentStateChoiceID === "kitchen_inrail") {
                return "views/browse/range-info/browse-range-info-kitchen-inrail.htm";
            }

            if (parentStateChoiceID === "bedroom_flat_pack") {
                return "views/browse/range-info/browse-range-info-bedroom-flat-pack.htm";
            }

            if (parentStateChoiceID === "valore") {
                return "views/browse/range-info/browse-range-info-valore.htm";
            }

            if (parentStateChoiceID === "ora") {
                return "views/browse/range-info/browse-range-info-ora.htm";
            }

            if (parentStateChoiceID === "jayline") {
                return "views/browse/range-info/browse-range-info-jayline.htm";
            }

            if (parentStateChoiceID === "wilton") {
                return "views/browse/range-info/browse-range-info-wilton.htm";
            }

            if (parentStateChoiceID === "bella") {
                return "views/browse/range-info/browse-range-info-bella.htm";
            }

            if (parentStateChoiceID === "zurfiz") {
                return "views/browse/range-info/browse-range-info-zurfiz.htm";
            }

            if (parentStateChoiceID === "thornbury") {
                return "views/browse/range-info/browse-range-info-thornbury.htm";
            }

            if (parentStateChoiceID === "hadley") {
                return "views/browse/range-info/browse-range-info-hadley.htm";
            }

            if (parentStateChoiceID === "lacarre") {
                return "views/browse/range-info/browse-range-info-lacarre.htm";
            }

            if (parentStateChoiceID === "clicbox") {
                return "views/browse/range-info/browse-range-info-clicbox.htm";
            }

            if (parentStateChoiceID === "hettich") {
                return "views/browse/range-info/browse-range-info-hettich.htm";
            }
        }

        if (parentStateModelID === "info") {
            if (parentStateChoiceID === "fira_level_h") {
                return "views/browse/range-info/info/browse-range-info-info-fira-level-h-rigid-kitchen.htm";
            }
            if (parentStateChoiceID === "hinge_drawer_information") {
                return "views/browse/range-info/info/browse-range-info-info-hinge-drawer.htm";
            }
        }

        if (parentStateModelID === "browse") {
            if (parentStateChoiceID === "edit") {
                return "views/browse/edit/browse-edit.htm";
            }
        }

        return "views/browse/layout/browse-layout-any.htm";
    }
}]);
